export default "__VITE_ASSET__7a4dc097__"